module.exports = __webpack_public_path__ + "img/ch27.e8ed8331.jpg";